module.exports = __webpack_public_path__ + "img/uebersee-festival.52d2cc1d.png";